import React from "react";
import { observer } from "mobx-react";
import { LlmProviderCreateStore } from "../../store";
import { LlmProviderCreateForm } from "./LlmProviderCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type LlmProviderCreateProps = {
  llmProviderCreateStore: LlmProviderCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const LlmProviderCreate: React.FC<LlmProviderCreateProps> = observer(
  ({ llmProviderCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={llmProviderCreateStore.isSaving} />
        <LlmProviderCreateForm
          llmProviderCreateStore={llmProviderCreateStore}
          nameError={llmProviderCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            llmProviderCreateStore.setNameValue(value);
          }}
          name={llmProviderCreateStore.entityValues.name}
          codeError={llmProviderCreateStore.errors.code?.message}
          onCodeChange={(value: string) => {
            llmProviderCreateStore.setCodeValue(value);
          }}
          code={llmProviderCreateStore.entityValues.code}
          requiresApiKeyError={
            llmProviderCreateStore.errors.requiresApiKey?.message
          }
          onRequiresApiKeyChange={(value: boolean) => {
            llmProviderCreateStore.setRequiresApiKeyValue(value);
          }}
          requiresApiKey={llmProviderCreateStore.entityValues.requiresApiKey}
          requiresBaseUrlError={
            llmProviderCreateStore.errors.requiresBaseUrl?.message
          }
          onRequiresBaseUrlChange={(value: boolean) => {
            llmProviderCreateStore.setRequiresBaseUrlValue(value);
          }}
          requiresBaseUrl={llmProviderCreateStore.entityValues.requiresBaseUrl}
          defaultModelsError={
            llmProviderCreateStore.errors.defaultModels?.message
          }
          onDefaultModelsChange={(value: string[]) => {
            llmProviderCreateStore.setDefaultModelsValue(value);
          }}
          defaultModels={llmProviderCreateStore.entityValues.defaultModels}
          logoUrlError={llmProviderCreateStore.errors.logoUrl?.message}
          onLogoUrlChange={(value: string) => {
            llmProviderCreateStore.setLogoUrlValue(value);
          }}
          logoUrl={llmProviderCreateStore.entityValues.logoUrl}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={llmProviderCreateStore.isProcessing}
          onSave={() => llmProviderCreateStore.saveNewLlmProvider()}
          onCancel={() => llmProviderCreateStore.cancelNewLlmProvider()}
        />
        <ErrorDialog
          open={llmProviderCreateStore.errorDialogOpened}
          title={llmProviderCreateStore.errorTitle}
          description={llmProviderCreateStore.errorDescription}
          onClose={() => llmProviderCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
